const titles = document.getElementsByClassName('accordion__title');

for (let i = 0; i < titles.length; i++) {
    titles[i].addEventListener('click', function(event) {
        const target = event.currentTarget as Element;
        const active = target.classList.toggle('accordion__title--active');

        target.setAttribute('aria-expanded', String(active));
        target.parentElement?.classList.toggle('accordion__heading--active', active);
    });
}
